import React from 'react';
import { BarRaiserLeaderboard } from './BarRaiserLeaderboard';
import { WorkflowTableContext } from '../../contexts/WorkflowTableContext';
import ContentWorkflowTableV3 from '../workflow-viewer/ContentWorkflowTableV3';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { useBarRaisers } from '../content/table/Hooks';
import { ServerSideQueryContentsProvider } from '../content/table/ServerSideQueryContentsProvider';
import { BarRaiserDashboardTabProps } from './DraftBarRaiserDashboard';
import constants from '../../common/constants';
import { publishedBarRaiserDashboardDefaultSort } from '../workflow-viewer/ContentWorkflowTableDefinitions';

export const PublishedBarRaiserDashboard = (props: BarRaiserDashboardTabProps) => {
  const {
    techDomain,
    headerSuffix,
    queryGroups,
    queryGroupsOperation,
    allContentTableColumns,
    contentSelectorOptions,
  } = props;
  const header = `${constants.BAR_RAISER_DASHBOARD_HEADER} - ${headerSuffix}`;

  const tableDataProvider = (
    <ServerSideQueryContentsProvider
      queryGroups={queryGroups}
      queryGroupOperation={queryGroupsOperation}
      tableId={WorkflowTableIdentity.PublishedBarRaiserDashboard}
    />
  );

  const fetchBarRaisersState = useBarRaisers(techDomain);

  return (
    <div>
      <BarRaiserLeaderboard techDomain={techDomain} />
      <br />
      <WorkflowTableContext.Provider value={{ fetchBarRaisersState }}>
        <ContentWorkflowTableV3
          tableId={WorkflowTableIdentity.PublishedBarRaiserDashboard}
          header={header}
          columnDefinitions={allContentTableColumns}
          tableSelectorOptions={contentSelectorOptions}
          tableDataProvider={tableDataProvider}
          sortingOption={publishedBarRaiserDashboardDefaultSort}
          stickyColumns={{ first: 2, last: 0 }}
        />
      </WorkflowTableContext.Provider>
    </div>
  );
};
